import $ from 'jquery';
class Search {

	constructor(element) {
		$(document).ready(() => this.load());
	}

	load() {
		this.searchEl = $('.twz-element-search');
		this.toggleBtn = $('[data-toggle="search"]');
		this.overlay = $('.twz-overlay');

		this.toggleBtn.on('click',(e) => this.toggleNav());
		this.overlay.on('click', (e) => function(e){
			if(searchEl.hasClass('is-expanded')) {
				this.toggleNav(e);
			}
		})
	}

	toggleNav(e) {
		$('body').toggleClass('no-scroll');
		$('body').toggleClass('search-expanded');
		this.searchEl.toggleClass('is-expanded');
		this.overlay.toggleClass('twz-overlay--is-active');
		this.toggleBtn.toggleClass('active');
	}
}

new Search